// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Xi2C","textarea":"styles_textarea__HkOeo"};